// Экраны меты: splash, карта уровней («лента роста»), рейтинг.
// Карта — вертикальная лента силуэтов по возрастанию высоты, уровень 1 внизу.
// Пройденные уровни подсвечены красным Этажей.
import { resetBlueprint } from './blueprint.mjs';

const el = (id) => document.getElementById(id);

// Мини-силуэт здания: стилизованный SVG по параметрам уровня
function silhouetteSvg(level, state) {
  const h = 18 + Math.round(Math.sqrt(level.floors) * 5.5); // 30..73
  const w = 30;
  const color = state === 'done' ? '#E2231A' : state === 'open' ? '#2B2B2B' : '#b9bec4';
  let shapes = '';
  if (level.tiers) {
    // Ярусный силуэт (МГУ, Тайбэй, Бурдж)
    const t1 = Math.round(h * 0.5), t2 = Math.round(h * 0.32), t3 = h - t1 - t2;
    shapes = `<rect x="4" y="${80 - t1}" width="22" height="${t1}"/>
      <rect x="8" y="${80 - t1 - t2}" width="14" height="${t2}"/>
      <rect x="12" y="${80 - h}" width="6" height="${t3}"/>`;
  } else if (level.twistPerFloor) {
    // Закрученный: слегка скошенные секции
    shapes = `<polygon points="6,80 24,80 22,${80 - h * 0.55} 8,${80 - h * 0.55}"/>
      <polygon points="8,${80 - h * 0.55} 22,${80 - h * 0.55} 19,${80 - h} 11,${80 - h}"/>`;
  } else {
    shapes = `<rect x="6" y="${80 - h}" width="18" height="${h}"/>`;
  }
  if (level.spire) shapes += `<rect x="14.2" y="${80 - h - 9}" width="1.6" height="9"/>`;
  return `<svg viewBox="0 0 ${w} 82" width="30" height="82" fill="${color}" xmlns="http://www.w3.org/2000/svg">${shapes}</svg>`;
}

export function createScreens({ onPlay, onLeaderboard }) {
  el('splash-play').addEventListener('click', () => {
    el('splash').classList.add('hidden');
    el('map').classList.remove('hidden');
  });
  el('map-close').addEventListener('click', () => el('map').classList.add('hidden'));
  el('map-board').addEventListener('click', () => onLeaderboard());
  el('board-close').addEventListener('click', () => el('board').classList.add('hidden'));

  el('board-tab-all').addEventListener('click', () => switchTab('all'));
  el('board-tab-week').addEventListener('click', () => switchTab('week'));

  let boardData = { top: [], weekly: [] };

  function switchTab(tab) {
    el('board-tab-all').classList.toggle('active', tab === 'all');
    el('board-tab-week').classList.toggle('active', tab === 'week');
    renderRows(tab === 'all' ? boardData.top : boardData.weekly);
  }

  function renderRows(rows) {
    el('board-list').innerHTML = rows.length
      ? rows.map((r) => {
        // Подпись общего зачёта: сколько уровней взято и лучшая высота
        const parts = [];
        if (r.levels) parts.push(`${r.levels} ур.`);
        if (r.floors) parts.push(`${r.floors} эт.`);
        const sub = parts.length ? `<span class="sub">${parts.join(' · ')}</span>` : '';
        return `
        <div class="board-row${r.you ? ' you' : ''}">
          <span class="place">${r.place}</span>
          <span class="name">${escapeHtml(r.name)}${sub}</span>
          <span class="pts">${r.score.toLocaleString('ru-RU')}</span>
        </div>`;
      }).join('')
      : '<div class="board-empty">Пока пусто. Сыграй первым — и займёшь весь пьедестал!</div>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  return {
    showSplash() {
      el('splash').classList.remove('hidden');
    },

    // levels — конфиг; unlocked — индекс последнего доступного; best — {level: score}
    renderMap(levels, unlocked, best, starsMap = {}, onForeman = null) {
      const rows = [...levels].reverse().map((lvl) => {
        const i = lvl.id - 1;
        const state = best[lvl.id] != null ? 'done' : i <= unlocked ? 'open' : 'locked';
        const st = starsMap[lvl.id] || 0;
        // Звёзды уровня: ★★☆ под подписью; за 3⭐ — каска «Прораб ×2»
        const starsHtml = state === 'done'
          ? `<div class="lv-stars">${'<span class="on">★</span>'.repeat(st)}${'<span>★</span>'.repeat(3 - st)}</div>`
          : '';
        const foremanHtml = st === 3 && onForeman
          ? `<button class="lv-foreman" data-flevel="${i}">🪖 Прораб ×2</button>`
          : '';
        const right = state === 'done'
          ? `<div class="lv-score">★ ${best[lvl.id].toLocaleString('ru-RU')}</div>${foremanHtml}<div class="lv-go">Ещё раз</div>`
          : state === 'open'
            ? '<div class="lv-go primary">Играть</div>'
            : '<div class="lv-lock">🔒</div>';
        return `
          <div class="lv-row ${state}" data-level="${i}">
            <div class="lv-sil">${silhouetteSvg(lvl, state)}</div>
            <div class="lv-info">
              <div class="lv-name">${lvl.id}. ${lvl.name}
                ${state !== 'locked' ? `<button class="lv-bp" data-blevel="${i}" title="Показать чертёж">i</button>` : ''}
              </div>
              <div class="lv-sub">${lvl.subtitle} · ${lvl.floors} эт.</div>
              ${starsHtml}
            </div>
            <div class="lv-right">${right}</div>
          </div>`;
      }).join('');
      el('map-list').innerHTML = rows;
      for (const row of el('map-list').querySelectorAll('.lv-row.open, .lv-row.done')) {
        row.addEventListener('click', () => {
          el('map').classList.add('hidden');
          onPlay(Number(row.dataset.level));
        });
      }
      for (const btn of el('map-list').querySelectorAll('.lv-foreman')) {
        btn.addEventListener('click', (e) => {
          e.stopPropagation(); // клик по каске не должен запускать обычный уровень
          el('map').classList.add('hidden');
          onForeman(Number(btn.dataset.flevel));
        });
      }
      // Кнопка «i»: сбросить отметку «чертёж показан» и запустить уровень с интро
      for (const btn of el('map-list').querySelectorAll('.lv-bp')) {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const i = Number(btn.dataset.blevel);
          resetBlueprint(levels[i].id);
          el('map').classList.add('hidden');
          onPlay(i);
        });
      }
      // Лента роста: старт внизу, у первого уровня
      requestAnimationFrame(() => { el('map-list').scrollTop = el('map-list').scrollHeight; });
    },

    showMap() { el('map').classList.remove('hidden'); },
    hideMap() { el('map').classList.add('hidden'); },

    // Экран скинов: превью-палитра, порог звёзд, выбор доступного.
    // eventSkinId — скин-подарок активного ивента: открыт всем на его время.
    renderSkins(skins, totalStars, selectedId, onPick, eventSkinId = null) {
      el('skins-sub').textContent = `Твои звёзды: ${totalStars} ★ — собирай по 3 на уровне`;
      el('skins-list').innerHTML = skins.map((s) => {
        const byEvent = s.id === eventSkinId && totalStars < s.stars;
        const open = totalStars >= s.stars || s.id === eventSkinId;
        const sel = s.id === selectedId;
        const c = s.colors || { wall: '#f2efe9', win: '#3d5466', band: '#e2231a' };
        const state = sel ? '✓ Выбран' : byEvent ? '🎁 Ивент' : open ? 'Выбрать' : `🔒 ${s.stars} ★`;
        return `
          <div class="skin-row ${open ? 'open' : 'locked'} ${sel ? 'selected' : ''}" data-skin="${s.id}">
            <div class="skin-swatch" style="background:linear-gradient(180deg, ${c.wall} 0%, ${c.wall} 58%, ${c.band} 58%, ${c.band} 72%, ${c.wall} 72%)">
              <i style="background:${c.win}"></i><i style="background:${c.win}"></i><i style="background:${c.win}"></i>
            </div>
            <div class="skin-info">
              <b>${s.title}</b>
              <span>${byEvent ? 'В подарок на время ивента' : s.desc}</span>
            </div>
            <div class="skin-state">${state}</div>
          </div>`;
      }).join('');
      for (const row of el('skins-list').querySelectorAll('.skin-row.open')) {
        row.addEventListener('click', () => onPick(row.dataset.skin));
      }
    },
    showSkins() { el('skins').classList.remove('hidden'); },
    hideSkins() { el('skins').classList.add('hidden'); },

    showBoard(data) {
      boardData = data;
      el('board').classList.remove('hidden');
      switchTab('all');
    },
  };
}
